"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsReducers = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const publicSettingsSlice_1 = require("./publicSettingsSlice");
const settingsSlice_1 = require("./settingsSlice");
exports.settingsReducers = {
    editableSettings: (0, toolkit_1.combineReducers)({
        settings: settingsSlice_1.settingsSlice.reducer,
        publicSettings: publicSettingsSlice_1.publicSettingsSlice.reducer,
    }),
};
